<section class="page-stack">
  <div class="section-header">
    <div>
      <p class="eyebrow mb-1">Employer Management</p>
      <h2>Employers</h2>
    </div>
  </div>

  <div class="panel p-3">
    <form class="row g-3 align-items-end" (ngSubmit)="create()">
      <div class="col-md-5">
        <label class="form-label">Company name</label>
        <input class="form-control" name="company_name" [(ngModel)]="form.company_name" required>
      </div>
      <div class="col-md-5">
        <label class="form-label">Physical location</label>
        <input class="form-control" name="business_location" [(ngModel)]="form.business_location" required>
      </div>
      <div class="col-md-2">
        <button class="btn btn-accent w-100" [disabled]="saving || !form.company_name || !form.business_location">
          {{ saving ? 'Creating...' : 'Create' }}
        </button>
      </div>
    </form>
  </div>

  <div class="panel">
    <div class="table-responsive">
      <table class="table table-dark table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>Employer</th>
            <th>Code</th>
            <th>Location</th>
            <th>Documents</th>
            <th>Status</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          @if (loading) {
            <tr><td colspan="6" class="text-center py-4">Loading employers...</td></tr>
          } @else if (employers.length === 0) {
            <tr><td colspan="6" class="text-center py-4 text-muted-soft">No employers created yet.</td></tr>
          } @else {
            @for (employer of employers; track employer.id) {
              <tr>
                <td class="fw-semibold">{{ employer.company_name }}</td>
                <td><span class="badge text-bg-info">{{ employer.employer_code || 'Pending' }}</span></td>
                <td>{{ employer.business_location || '-' }}</td>
                <td>{{ documentCount(employer) }}/5 complete</td>
                <td><span class="status-pill" [class.status-muted]="employer.status !== 'active'">{{ employer.status }}</span></td>
                <td class="text-end">
                  <a class="btn btn-sm btn-outline-info" [routerLink]="['/employers', employer.id]">Manage</a>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pagination-row">
      <span>Page {{ page }} of {{ totalPages }}</span>
      <div class="btn-group btn-group-sm">
        <button class="btn btn-outline-light" (click)="go(-1)" [disabled]="page === 1">Prev</button>
        <button class="btn btn-outline-light" (click)="go(1)" [disabled]="page === totalPages">Next</button>
      </div>
    </div>
  </div>

  @if (notice) {
    <div class="alert alert-info">{{ notice }}</div>
  }
  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
</section>
